const { Descriptions } = require("antd");

var elementTools = require("../../../webvowl/util/elementTools")();


module.exports = function (menu) {

	//Базовый класс фильтра, который использует значение из annotations у узла
  class AnnotationFilter {
    constructor(key) {
      this.key = key;
    }
    filter (annotations) { return false; }
  }

	//Включение и отключение по одному значению
	class AnnotationFilterValue extends AnnotationFilter{
		constructor(key, value) {
			super(key);          
      this.value = value;
		}

		filter (annotations){
			return Array.isArray(annotations[this.key])
				? annotations[this.key].filter(item => item.value === this.value).length>0
				:	false;
		}
	}

		//Включение и отключение по одному выбранному значению
	class AnnotationFilterSelect extends AnnotationFilter{
		constructor(key, value) {
			super(key);          
      this.value = value;
		}

		filter (annotations){
			return Array.isArray(annotations[this.key])
				? annotations[this.key].filter(item => item.value === this.value).length==0
				:	false;
		}
	}

	//Включение и отключение по массиву значение
	class AnnotationFilterArray extends AnnotationFilter{
		constructor(key, values) {
			super(key);          
      this.values = values;
		}

		filter (annotations){
			return Array.isArray(annotations[this.key])
				? annotations[this.key].filter(item => this.values.includes(item.value)).length>0
				: false;
		}
	};

	/** Класс элемент для отображения фильтра в меню */
	class Item {
		constructor(description, filter, index){
			this.name = description.name;
			this.group = description.group;
			this.filter = filter;
			this.index = index;
		}
	};

	/** Класс элемент для отображения фильтра в виде комбобокса в меню */
	class Items extends Item {
		constructor(description, filter, index){
			super(description, filter, index);
			this.items =description.items;
		}
	};

	var filter = {},
		nodes,
		properties,
		enabled = false,
		filteredNodes,
		filteredProperties,
		filterSettings=[], 	//Настройки фильтров. Элементы AnnotationFilter
		filterGroups=[],		//Списки групп в фильтра (группировка по элементам, например года, страны и т.п.)
		filterUsed=[],			//Применяемые фильтры (те у которых стоит галка)
		indexEnabled={};  	//Индекс элемента из filterSettings c флагами включены/выключены

	filter.initialize = function (nodes, properties) {
  	if(filterUsed.length > 0) {
      menu.getGraphObject().setFilterWarning(true);
		};
	};


	/**
	 * If enabled, all object properties and things without any other property are filtered.
	 * @param untouchedNodes
	 * @param untouchedProperties
	 */
	filter.filter = function (untouchedNodes, untouchedProperties) {
		console.log("annotationsNodeFilter.js filter start", indexEnabled, untouchedNodes.length, untouchedProperties.length);
		nodes = untouchedNodes;
		properties = untouchedProperties;

		filterUsed=[];
		for (let index = 0; index < filterSettings.length; index++) {
			if (indexEnabled[index]) 
				filterUsed.push(filterSettings[index]);
		};

		if (filterUsed.length>0){
			removeFilteredNodes();
		}
		filteredNodes = nodes;
		filteredProperties = properties.filter(property=>{
			return filteredNodes.includes(property.domain()) && filteredNodes.includes(property.range())
		});
		console.log("annotationsNodeFilter.js filter finish ", filteredNodes.length, filteredProperties.length);
	};

	function removeFilteredNodes() {
		nodes = nodes.filter(isNoInFilterAnnotation);
	}


	function isNoInFilterAnnotation(node) {
		for (const item of filterUsed){
			if (item.filter.filter(node.annotations())) return false;
		};
		return true;
		
	}

	filter.enabled = function (p) {
		if (!arguments.length) return enabled;
		enabled = p;
		return filter;
	};


	// Functions a filter must have
	filter.filteredNodes = function () {
		return filteredNodes;
	};

	filter.filteredProperties = function () {
		return filteredProperties;

	};

	/** Установка параметров фильтров. По списку фильтров формируется массив   */
  filter.setFilterSettings=function(settings){
		filterSettings = [];
		filterGroups = [];
    const conversionSettings = (settings)?JSON.parse(JSON.stringify(settings)):{};
		let index = 0;
		indexEnabled = {};
    if (conversionSettings.settings && conversionSettings.settings.extra_options && conversionSettings.settings.extra_options.filters){
			const annotationsSettings = conversionSettings.settings.extra_options.filters.filter(filter => filter.annotations);
			annotationsSettings.map(filter => {
				//Заголовок группы
				if (filter.group && !filterGroups.includes(filter.group))
					filterGroups.push(filter.group);
				
				Object.keys(filter.annotations).forEach(name => {
					if (Array.isArray(filter.annotations[name]))
						//Фильтр для массива значений
						filterSettings.push(new Item(filter, new AnnotationFilterArray(name, filter.annotations[name]), index));
					else {
						//Для выбираемого значения
						if (Array.isArray(filter.items))
							filterSettings.push(new Items(filter, new AnnotationFilterSelect(name, filter.annotations[name]), index));
						else 
							//Фильтр для одного  значения
							filterSettings.push(new Item(filter, new AnnotationFilterValue(name, filter.annotations[name]), index));
					};
					indexEnabled[index++] = (filter.hide)? "TRUE" === filter.hide.toUpperCase(): true;
				});
			});
		};
		filterUsed=[];
		for (let index = 0; index < filterSettings.length; index++) {
			if (indexEnabled[index]) 
				filterUsed.push(filterSettings[index]);
		};
	};

	filter.menuFilter = function () {
		return filterSettings;
	};

	/** Описание группы */
	filter.groupsFilter = function(){
		return filterGroups;
	};

	filter.indexEnabled = function (index, p=undefined) {
		if (p === undefined){
			if (filterSettings[index] instanceof Items)
				return filterSettings[index].filter.value;
			if (indexEnabled.hasOwnProperty(index)){
				return indexEnabled[index];
			};
			return true;
		}
			//Проверка, что пришло изменений от комбобокса
		if (filterSettings[index] instanceof Items){
			filterSettings[index].filter.value = p;
			return filter;
		}
		if (indexEnabled.hasOwnProperty(index)){
			indexEnabled[index] = p;
		}
		return filter;
	};

	return filter;
};
